<label>{{ to.label }} @if (to.required) {
  <span>*</span>
} </label>

<ng-select
  dropdownPosition="top"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [placeholder]="to.label + (to.required ? '*' : '')"
  >
  @for (page of pages; track page) {
    <ng-option [value]="page.config.id">
      {{ page.config.name }}
    </ng-option>
  }
</ng-select>
